import(/* webpackMode: "eager" */ "/home/runner/work/erp_accelerator/erp_accelerator/frontend/app/error.tsx");
